// validate doctor expenditure response data
// file: DoctorExpenditureBarChart.js && DoctorExpenditurePieChart.js
// url: '/api/analysis/doctor_prices'
export const validateDoctorExpenditure = (data) => {
    if (data === null || data === undefined) {
        return false;
    }

    return Array.isArray(data) && data.every((object) => (
        typeof object === 'object' &&
        typeof object.total_cost === 'string' &&
        typeof object.accepted_cost === 'string' &&
        typeof object.rejected_cost === 'string' &&
        typeof object.provider === 'string'
    ));
};

// validate frequency doctor expenditure response data
// file: frequencyCharts/DoctorExpenditureBarChart.js
// url: '/api/analysis/doctor_prices'
export const validateFrequencyDoctorExpenditure = (data) => {
    if (data === null || data === undefined) {
        return false;
    }

    return Array.isArray(data) && data.every((item) =>
        typeof item['provider_name'] === 'string' &&
        typeof item['type'] === 'string' &&
        Array.isArray(item['cost']) &&
        item['cost'].every((element) => typeof element === 'string') &&
        Array.isArray(item['date_list']) &&
        item['date_list'].every((element) => typeof element === 'string')
    );
};

// validate most used drugs response data
// file: MostUsedDrugsPieChart.js
// url: '/api/analysis/most_used_drugs'
export const validateMostUsedDrugs = (data) => {
    if (data === null || data === undefined) {
        return false;
    }

    return typeof data === 'object' &&
           Array.isArray(data['most_used_drugs']) &&
           data['most_used_drugs'].every((object) => (
               typeof object === 'object' &&
               typeof object.drug_name === 'string' &&
               typeof object.drug_count === 'number'
           ));
};

// validate most used diagnosis response data
// file: MostUsedIcdsPieChart.js
// url: '/api/analysis/most_used_icds'
export const validateMostUsedDiagnosis = (data) => {
    if (data === null || data === undefined) {
        return false;
    }

    return typeof data === 'object' &&
           Array.isArray(data['most_used_icds']) &&
           data['most_used_icds'].every((object) => (
               typeof object === 'object' &&
               typeof object.icd_code === 'string' &&
               typeof object.icd_count === 'number'
           ));
};

// validate encounter state chart response data
// files: StatePieChart.js, app-context
// url: '/api/analysis/encounter_state'
export const validateStateChart = (data) => {
    if (data === null || data === undefined) {
        return false;
    }

    return Array.isArray(data) && data.every((object) => (
        typeof object === 'object' &&
        typeof object.state === 'string' &&
        typeof object.state_count === 'number'
    ));
};

// validate user profile response
// file: auth-context.js
// url: '/api/user/me'
export const validateUserProfile = (data) => {
    if (data === null || data === undefined || typeof data !== 'object' || typeof data['user'] !== 'object') {
        return false;
    }

    const {
        id,
        name,
        email,
        gender,
        birthdate,
        age,
        roles
    } = data['user'];

    return (
        typeof data['id'] === 'number' &&
        typeof id === 'number' &&
        typeof name === 'string' &&
        typeof email === 'string' &&
        typeof gender === 'string' &&
        typeof birthdate === 'string' &&
        typeof age === 'number' &&
        Array.isArray(roles)
    );
};

// validate new user response
// files: NewUserForm EncounterCard EncounterCardInsurance NewEncounterPage PatientProfilePage
// url: '/api/user/patientprofile/create'
export const validateUserResponse = (data) => {
    if (data === null || data === undefined) {
        return false;
    }

    const { id, primary_insurance_name, secondary_insurance_name, user } = data;

    return (
        typeof id === 'number' &&
        typeof primary_insurance_name === 'string' &&
        typeof secondary_insurance_name === 'string' &&
        typeof user === 'object'
    );
};

export const validateNewDoctorResponse = (data) => {
    if (data === null || data === undefined) {
        return false;
    }

    const { id, user, facility } = data;

    return (
        typeof id === 'number' &&
        typeof facility === 'number' &&
        typeof user === 'object'
    );
};

// validate patient diagnosis
// files: PatientProfilePage
// url: '/api/patient/encounter/icd/patientid/'
export const validatePatientDiagnosis = (data) => {
    if (data === null || data === undefined) {
        return false;
    }

    return Array.isArray(data) && data.every((object) => {
        const { id, icd, shortdescription, date } = object;
        return (
            typeof id === 'number' && 
            typeof icd === 'string' &&
            typeof shortdescription === 'string' &&
            typeof date === 'string'
        );
    });
};

// validate icd options
// file: DiagnoseSelect
// url: 'api/medical/codes/icds/search'
export const validateIcdCode = (data) => {
    if (data === null || data === undefined) {
        return false;
    }

    return Array.isArray(data) && data.every((object) => {
        const { icdcode, shortdescription } = object;
        return (
            typeof icdcode === 'string' &&
            typeof shortdescription === 'string'
        );
    });
}

// validate cpt options
// file: ProcedureSelect
// url: 'api/medical/codes/cpts/search'
export const validateCptCode = (data) => {
    if (data === null || data === undefined) {
        return false;
    }

    return Array.isArray(data) && data.every((object) => {
        const { cptcode, shortdescription } = object;
        return (
            typeof cptcode === 'string' &&
            typeof shortdescription === 'string'
        );
    });
}

// validate drug options
// file: DrugName
// url: 'api/medical/codes/drugs/search'
export const validateDrugsCode = (data) => {
    if (data === null || data === undefined) {
        return false;
    }

    return Array.isArray(data) &&
    data.every((object) => (
        typeof object.product_id === 'number' &&
        typeof object.product_brand_name === 'string'
    ));
};

// validate drugs for patient profile
// file:PatientProfilePage
// url: '/api/patient/encounter/drug/patientid/'
export const validatePatientProfileDrugsCode = (data) => {
    if (data === null || data === undefined) {
        return false;
    }

    return Array.isArray(data) &&
    data.every((object) => (
        typeof object.drug.product_id === 'number' &&
        typeof object.packagename === 'string'
    ));
};

// validate user encounters
// files: NewEncounterForm, PatientProfilePage
// url: '/api/patient/encounter/patientid/'
export const validateUserEncounters = (data) => {
    if (data === null || data === undefined) {
        return false;
    }

    return typeof data.count === 'number' &&
    Array.isArray(data.results);
};

// validate new encounter
// files: NewEncounterForm, EncounterCard, eEncounterCardInsurance
// url: '/api/patient/encounter/create/'
export const validateAnEncounter = (data) => {
    if (data === null || data === undefined) {
        return false;
    }

    const { id, provider, patient } = data;
    return typeof id === 'number' &&
     typeof provider === 'number' &&
     typeof patient === 'number';
};

// validate encounters list
// files: DoctorProfilePage, FacilityProfilePage, InsuranceProfilePage, PharmacyProfilePage
// url: '/api/patient/encounters/'
export const validateEncountersList = (data) => {
    if (data === null || data === undefined) {
        return false;
    }

    const { count, results } = data;
    return typeof count === 'number' &&
    Array.isArray(results);
};

// validate insurance and facilities list
// files: Settings, NewUserForm
export const validateInsuranceAndFacilitiesList = (data) => {
    if (data === null || data === undefined) {
        return false;
    }

    return Array.isArray(data) && data.every((object) => (
        typeof object.id === 'number' && 
        typeof object.register_id === 'string'
    ));
};

// validate alternative drugs
// file: DrugName
export const validateAlternativeDrugs = (data) => {
    if (data === null || data === undefined) {
        return false;
    }

    const { count, results } = data;
    return typeof count === 'number' &&
    Array.isArray(results) && results.every((object) => (
        typeof object.product_id === 'number' &&
        typeof object.product_brand_name === 'string'
    ));
};

export const validateUpdatedUserPassword = (data) => {
    if (data === null || data === undefined) {
        return false;
    }

    const { id, email, name } = data;
    return typeof id === 'number' &&
    typeof email === 'string' &&
    typeof name === 'string';
};

export const validateAuthFormToken = (data) => {
    if (data === null || data === undefined) {
        return false;
    }

    return typeof data === 'object' &&
    typeof data.token === 'string'
}

export const validateRelatedDrugs = (data) => {
    if (data === null || data === undefined) {
        return false;
    }

    return Array.isArray(data) && data.every((object) => (
        typeof object.product_id === 'number' &&
        typeof object.product_brand_name === 'string'
    ))
}

export const validateRelatedProcedures = (data) => {
    if (data === null || data === undefined) {
        return false;
    }

    return Array.isArray(data) && data.every((object) => (
        typeof object.cptcode === 'string' &&
        typeof object.shortdescription === 'string'
    ))
}

export const validateFavourite = (data) => {
    if (data === null || data === undefined) {
        return false;
    }

    const {id, provider, icds, drugs, cpts} = data

    return typeof id === 'number' &&
    typeof provider === 'number' &&
    Array.isArray(icds) &&
    Array.isArray(drugs) &&
    Array.isArray(cpts)
}

export const validatePatientProcedures = (data) => {
    if (data === null || data === undefined) {
        return false;
    }

    return Array.isArray(data) && data.every((object) => {
        const { id, cpt, shortdescription, date } = object;
        return (
            typeof id === 'number' &&
            typeof cpt === 'string' &&
            typeof shortdescription === 'string' &&
            typeof date === 'string'
        );
    });
};

export const validateOpenAiSessionId = (data) => {
    if (data === null || data === undefined) {
        return false;
    }
    const {session_id} = data
    return typeof session_id === 'string'
}

export const validateOpenAiAssistantResponse = (data) => {
    if (data === null || data === undefined) {
        return false;
    }
    const {response} = data
    return typeof response === 'string'
}

export const validateNlpResponse = (data) => {
    if (data === null || data === undefined) {
        return false;
    }

    const {id, content, response} = data

    return typeof id === 'number' &&
    typeof content === 'string' &&
    Array.isArray(response.Entities) && response.Entities.every((object) => {
        const {Id, Category, ICD10CMConcepts} = object
        return typeof Id === 'number' &&
        typeof Category === 'string' &&
        Array.isArray(ICD10CMConcepts) && ICD10CMConcepts.every((object) => {
            const {Code} = object
            return typeof Code === 'string'
        })
    })
}

export const validatePharmacyList = (data) => {
    if (data === null || data === undefined) {
        return false;
    }

    return Array.isArray(data) && data.every((object) => (
        typeof object.id === 'number' &&
        typeof object.name === 'string'
    ))
}

export const validateStatistics = (data) => {
  if (!data) {
    return false;
  }

  return Object.keys(data).every(
    key => data[key] && (typeof data[key].value === 'number' || typeof data[key].value === 'string')
  );
};

export const validateStatisticsKey = (data) => {
  if (!data) return false;

  return Object.keys(data).every(key => {
    const value = data[key];

    if (key === 'most_used_drug') {
      return true;
    }

    return typeof value === 'number';
  });
};

export const validateRefills = (data) => {
    if (data === null || data === undefined) {
        return false;
    }

    return Array.isArray(data) && data.every((object) => (
        typeof object.patient_name === 'string' &&
        typeof object.product_brand_name === 'string'
    ))
}

export const validatePatientAbuseTable = (data) => {
    if (!Array.isArray(data)) return false;

    return data.every((object) =>
        typeof object.patient_name === 'string' &&
        Array.isArray(object.patient_records) &&
        object.patient_records.every(
            (record) => typeof record.provider === 'string'
        )
    );
};

export const validateEncounterRejectionDistributionData = (data) => {
  if (!data) return false;

  return Object.keys(data).every(key => {
    const value = data[key];
    const { encounters_count, encounters_percentage } = value

    return typeof encounters_count === 'number' &&
    typeof encounters_percentage ==='string'
  });
}

export const validateHighDrugSpend = (data) => {
  if (!data) return false;

   return Array.isArray(data) && data.every((object) => (
        typeof object.name === 'string'
    ))
}

export const validatePatientsWithExcessiveEncounterFrequency = (data) => {
  if (!data) return false;
  return Array.isArray(data) && data.every((object) => (
        typeof object.patient === 'string'
    ))
}

export const validateProvidersWithHighRejectionRates = (data) => {
    if(!data) return false;
    return Array.isArray(data) && data.every((object) => (
        typeof object.provider_name === 'string'
    ))
}

export const validateExpensiveDrugPrescribingProviders = (data) => {
    if(!data) return false;
    return Array.isArray(data) && data.every((object) => (
        typeof object.name === 'string'
    ))
}

export const validatePricesTable = (data) => {
    if (data === null || data === undefined) {
        return false;
    }

    const { count, results } = data;
    return typeof count === 'number' &&
    Array.isArray(results);
};

export const validatePendingToDispenseEncounters = (data) => {
    if (data === null || data === undefined) {
        return false;
    }

    return typeof data.count === 'number' &&
    Array.isArray(data.results);
};

export const validatePendingToDispenseEncounter = (data) => {
    if (data === null || data === undefined) {
        return false;
    }
    const { id } = data;

    return typeof id === 'number'
}

export const validatePendingToDispenseStatistics = (data) => {
    if (data === null || data === undefined) {
        return false;
    }

    const {queued_encounters} = data

    return typeof queued_encounters === 'number'
}

export const validateDispensedDrugs = (data) => {
    if (data === null || data === undefined) {
        return false;
    }

    return Array.isArray(data) && data.every((object) => {
        const {id, dispensed_by} = object
        return typeof id === 'number' &&
        typeof dispensed_by === 'number'
    })
}

export const validateDrugsInventory = (data) => {
    if (data === null || data === undefined) {
        return false;
    }

    return Array.isArray(data) && data.every((object) => {
        const {id, pharmacy} = object
        return typeof id === 'number' &&
        typeof pharmacy === 'number'
    })
}

export const validateLabTestResults = (data) => {
    if (data === null || data === undefined) {
        return false;
    }

    return Array.isArray(data) && data.every((object) => {
        const {id, cpt_description} = object
        return typeof id === 'number' &&
        typeof cpt_description === 'string'
    })
    
}



